import * as React from 'react';
import { color, Button, ButtonGroup, AbsoluteBox, Box, Overlay, Typography } from '@kistech/kis-ui';
import { ActionOverlayProps } from './types';
import { useStyles } from './styled';
import { Grid, Box as MuiBox } from '@mui/material';
/**
 * Overlay used for Actions
 */

export const ActionOverlay = (props: ActionOverlayProps) => {
  const {
    title,
    description = '',
    confirmText,
    onConfirm,
    cancelText,
    onCancel,
    height,
    width: propsWidth,
    appearance
  } = props;

  const width = propsWidth || 700;
  const classes = useStyles({ width, height })();

  const onEl = (el: HTMLElement) => {
    const { style } = el;
    style.background = 'rgba(255,255,255,0.9)';
    style.zIndex = '2147483646';
    style.overflowX = 'hidden';
    style.overflowY = 'scroll';
  };

  return (
    <Overlay onEl={onEl}>
      <Grid container className={classes.actionOverlayContainer} direction="column">
        {/* Title */}
        <MuiBox className={classes.actionOverlayTitle}>
          {typeof title === 'string' ? (
            <Typography tag="h2" align="center" style={{ lineHeight: 1 }}>
              {title}
            </Typography>
          ) : (
            title
          )}
        </MuiBox>
        {/* Description */}
        <Box flexOverride="none" margin="5 0 7">
          {typeof description === 'string' ? (
            <Typography style={{ lineHeight: 1 }}>{description}</Typography>
          ) : (
            description
          )}
        </Box>

        {/* Cancel and Confirm Buttons */}
        <AbsoluteBox bottom="-45px">
          <ButtonGroup>
            {cancelText && (
              <Button
                size="large"
                color={color.BLACK}
                onClick={onCancel}
                appearance="white"
                className={classes.actionOverlayButtons}
              >
                {cancelText}
              </Button>
            )}
            <Button
              size="large"
              onClick={onConfirm}
              appearance={appearance ? appearance : 'primary'}
              className={classes.actionOverlayButtons}
            >
              {confirmText}
            </Button>
          </ButtonGroup>
        </AbsoluteBox>
      </Grid>
    </Overlay>
  );
};
